<template>
  <div class="container start-container">
    <div class="start-block">
      <div class="register-block">
        <form class="signForm">
          <div class="form__title">авторизация</div>
          <input
            type="text"
            name="Email"
            v-model.trim="email"
            :class="{
              error:
                ($v.email.$dirty && !$v.email.required) ||
                ($v.email.$dirty && !$v.email.email),
            }"
            placeholder="E-mail"
          />
          <label class="error" v-if="$v.email.$dirty && !$v.email.required">
            Поле 'E-mail' не должно быть пустым
          </label>
          <label class="error" v-else-if="$v.email.$dirty && !$v.email.email">
            Введите корректный e-mail
          </label>
          <input
            type="password"
            name="password"
            v-model.trim="password"
            :class="{
              error:
                ($v.password.$dirty && !$v.password.required) ||
                ($v.password.$dirty && !$v.password.minLength),
            }"
            placeholder="Пороль"
          />
          <label
            class="error"
            v-if="$v.password.$dirty && !$v.password.required"
          >
            Поле 'Пароль' не должно быть пустым
          </label>
          <label
            class="error"
            v-else-if="$v.password.$dirty && !$v.password.minLength"
          >
            Пароль должен быть не меньше 6 символов
          </label>
          <input
            type="submit"
            value="войти"
            id="register"
            v-on:click.prevent="sendForm"
          />
          <label class="remember-me">
            <input v-model="rememberMe" type="checkbox" class="remember-me__checkbox">
            <p>Запомнить меня</p>
          </label>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { email, required, minLength } from "vuelidate/lib/validators";
export default {
  data: () => ({
    email: "",
    password: "",
    rememberMe: false
    // email: "Alexander.burzev@gmail.com",
    // password: "1qazXSW@3edcVFR$",
  }),
  validations: {
    email: { email, required },
    password: { required, minLength: minLength(6) },
  },
  methods: {
    sendForm() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      } else {
        let data = {
          login: this.email,
          password: this.password,
        };
        this.$store
          .dispatch("LOGIN", data)
          .then((resp) => {
            this.$makeToast(
              "Поздравляем!",
              "success",
              "Вы успешно зарегистрированы! Добро пожаловать в ARTSTEP presentation"
            );
            this.$localStorageSet('miniCart', {})  //Пустая миникорзина в localStorage

            // Оля захотела кнопочку "запомнить пароль"
            if(this.rememberMe){
              this.$localStorageSet('rememberPassword', {
                'email': this.email,
                'password': this.password
              })
            }else{
              this.$localStorageSet('rememberPassword', {})
            }
              
            setTimeout(()=>{this.$router.push({name: 'mainPage'})}, 3000)
          })
          .catch((err) => {
            this.$makeToast(
              "Ошибка!",
              "danger",
              "Неправильный логин или пароль"
            );
          });
      }
    },
  },
  created(){
    // Оля захотела кнопочку "запомнить пароль"
    let rememberMeInfo = JSON.parse(localStorage.getItem('rememberPassword'));
    if(Object.keys(rememberMeInfo).length != 0){
      this.email = rememberMeInfo.email;
      this.password = rememberMeInfo.password;
      this.rememberMe = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.remember-me{
  display: flex;
  align-items: center;
  width: 100%;
  color: #fff;
  justify-content: center;
  .remember-me__checkbox{
    width: 15px;
    height: 15px;  
    margin: 0; 
    margin-right: 15px;
  }
}
</style>